<template>
  <div>
    <rd-column :size="$columns.TwelveOnLg">
      <div class="row">
        <rd-column
          :size="$columns.SixOnLg"
          v-for="(item, index) in databaseStatistics"
          :key="index"
        >
          <rd-header :title="getItemTitle(item)" type="primary" size="small" />
          <rd-header
            :title="getItemSizeTitle(item)"
            type="secondary"
            size="small"
          />
          <PieChart
            :data="[
              { type: $t(`statistics.used`), size: item.SpaceUsed },
              { type: $t(`statistics.remaining`), size: item.FreeSpace },
            ]"
            :palette="
              item.Type === databaseTypeEnum.PRIMARY ? 'Material' : 'Bright'
            "
          />
        </rd-column>
      </div>
    </rd-column>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { INDEX_STORE } from "../storeNames";

// i18n
import localMessages from "../locales";

// components
import PieChart from "./PieChart";

const databaseTypeEnum = Object.freeze({
  PRIMARY: 0,
  LOG: 1,
});

export default {
  name: "DatabaseUsage",
  data() {
    return {
      databaseStatistics: [],
      databaseTypeEnum,
    };
  },
  methods: {
    ...mapActions(INDEX_STORE, ["setDatabaseStatistics"]),
    getItemTitle(item) {
      return (
        item.Name +
        (item.Type === databaseTypeEnum.LOG
          ? ` - ${this.$t("index.logs")}`
          : "")
      );
    },
    getItemSizeTitle(item) {
      return `(${item.FileSize} MB)`;
    },
  },
  mounted() {
    this.setDatabaseStatistics().then((response) => {
      this.databaseStatistics = response.data;
    });
  },
  components: {
    PieChart,
  },
  i18n: {
    messages: localMessages.messages,
  },
};
</script>

